module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAsUAAAACCAYAAACwuaE9AAAAAXNSR0IArs4c6QAAAENJREFUWAnt0DERACAMALHC0sNFnYBCJHPMaCDv4NOqap6IFSJAgAABAgQIECDwocDI3P3Db8sECBAgQIAAAQIEHoELrjwChvhtl/4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company-client-landing-page--expanded--review-line.png
// module id = 1122
// module chunks = 0